import { render, staticRenderFns } from "./RfidVinculosItem.vue?vue&type=template&id=41ecd08a&scoped=true&"
import script from "./RfidVinculosItem.vue?vue&type=script&lang=js&"
export * from "./RfidVinculosItem.vue?vue&type=script&lang=js&"
import style0 from "./RfidVinculosItem.vue?vue&type=style&index=0&id=41ecd08a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ecd08a",
  null
  
)

export default component.exports